export default __webpack_public_path__ + "static/cube-map-banner-f3f3b6d68a6bce1208e5cc779acbe264.png";